var _rect, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoodsDisconnectedInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30.6691,
    height: 23.1775,
    rx: 3,
    fill: "#77B77C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.3753,
    cy: 11.3753,
    r: 4.3753,
    fill: "#FB6161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodsDisconnectedInactive);
export default __webpack_public_path__ + "static/media/GoodsDisconnectedInactive.be07e04cb4fae59427e714e39fa936a8.svg";
export { ForwardRef as ReactComponent };